import { Component, ChangeDetectionStrategy } from '@angular/core';

import { AppToastService } from '../toast-service/app-toast.service';
import { NgbToastModule } from '@ng-bootstrap/ng-bootstrap';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-toast-display',
  imports: [NgbToastModule, FaIconComponent],
  templateUrl: './toast-display.component.html',
  styleUrls: ['./toast-display.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ToastDisplayComponent {
  constructor(public toastService: AppToastService) {}

  protected readonly environment = environment;
}
